import React, { PropTypes } from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';

import Alert from 'AppComponents/Alert';


const FormattedDateTime = ({ value }) => (
  <time dateTime={value}>
    <FormattedDate
      value={value}
      day='numeric'
      month='long'
      year='numeric'
    />
    &nbsp;at&nbsp;
    <FormattedTime
      value={value}
      hour='numeric'
      minute='2-digit'
    />
  </time>
);

FormattedDateTime.propTypes = {
  value: PropTypes.string.isRequired,
};

const AlreadyReviewed = ({ item, reviewStatus }) => (
  <Alert type='success'>
    You have already reviewed this { item },
    and will be able to review it again on <FormattedDateTime value={reviewStatus.next_review} />.
  </Alert>
);

AlreadyReviewed.propTypes = {
  item: PropTypes.string.isRequired,
  reviewStatus: PropTypes.shape({
    next_review: PropTypes.string,
  }).isRequired,
};

export default AlreadyReviewed;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/BaseReview/ReviewForm/AlreadyReviewed.jsx